export default __webpack_public_path__ + "static/media/default.2fafc9235a7e14cfe8111ff22aaae39a.png";